/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';
import SkeletonText from '../SkeletonText/SkeletonText.js';

const AiSkeletonText = _ref => {
  let {
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const aiSkeletonTextClasses = cx(className, {
    [`${prefix}--skeleton__text--ai`]: true
  });
  return /*#__PURE__*/React__default.createElement(SkeletonText, _extends({
    className: aiSkeletonTextClasses
  }, rest));
};
AiSkeletonText.propTypes = {
  /**
   * Specify an optional className to be applied to the container node
   */
  className: PropTypes.string,
  /**
   * generates skeleton text at a larger size
   */
  heading: PropTypes.bool,
  /**
   * the number of lines shown if paragraph is true
   */
  lineCount: PropTypes.number,
  /**
   * will generate multiple lines of text
   */
  paragraph: PropTypes.bool,
  /**
   * width (in px or %) of single line of text or max-width of paragraph lines
   */
  width: PropTypes.string
};

export { AiSkeletonText as default };
